export const SET_ALREADY_WALLET_CONNECTED = 'SET_ALREADY_WALLET_CONNECTED'